import type { SVGProps } from 'react';
export const SvgEdit2 = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={20}
		height={20}
		fill="none"
		viewBox="0 0 20 20"
		{...props}
	>
		<path
			fill="#888"
			d="M4.617 16.267c-.509 0-.984-.175-1.325-.5-.434-.409-.642-1.025-.567-1.692l.308-2.7c.059-.508.367-1.183.725-1.55L10.6 2.583c1.708-1.808 3.492-1.858 5.3-.15s1.858 3.492.15 5.3l-6.842 7.242c-.35.375-1 .725-1.508.808l-2.683.459c-.142.008-.267.025-.4.025m8.658-13.842c-.642 0-1.2.4-1.767 1l-6.841 7.25c-.167.175-.359.592-.392.833l-.308 2.7c-.034.275.033.5.183.642s.375.192.65.15l2.683-.458c.242-.042.642-.259.809-.434l6.841-7.241c1.034-1.1 1.409-2.117-.1-3.534-.666-.641-1.241-.908-1.758-.908"
		/>
		<path
			fill="#888"
			d="M14.45 9.125h-.058A5.716 5.716 0 0 1 9.3 4.308a.635.635 0 0 1 .525-.716.635.635 0 0 1 .717.525 4.48 4.48 0 0 0 3.983 3.766.626.626 0 0 1 .558.684.645.645 0 0 1-.633.558M17.5 18.958h-15a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h15a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625"
		/>
	</svg>
);
